import React from "react";
import { Dialog } from "@actinc/dls/components";
import {
  Button,
  DialogActions,
  DialogContent,
  DialogTitle,
} from "@mui/material";
import { Backdrop } from "../";

const AlertDialog = ({
  children,
  confirmButtonText = "OK",
  customFooter,
  dialogTitle,
  fullWidth,
  loading,
  maxWidth = "md",
  message,
  onClose = () => {},
  open,
  showCancelBtn = true,
}) => {
  const handleClose = (value) => () => {
    onClose(value);
  };

  return (
    <Dialog
      onClose={handleClose()}
      open={open}
      maxWidth={maxWidth}
      fullWidth={fullWidth}
    >
      <DialogTitle>{dialogTitle}</DialogTitle>
      <Backdrop loading={loading} />
      <DialogContent aria-label="alert dialog content" dividers={true}>
        {message}
        {children}
      </DialogContent>
      <DialogActions>
        {customFooter || (
          <>
            {" "}
            {showCancelBtn && (
              <Button
                onClick={handleClose(false)}
                color="primary"
                variant="text"
              >
                Cancel
              </Button>
            )}
            <Button
              autoFocus
              onClick={handleClose(true)}
              color="primary"
              variant="text"
            >
              {confirmButtonText}
            </Button>
          </>
        )}
      </DialogActions>
    </Dialog>
  );
};

export { AlertDialog };
